import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import {
    ADDRESS_LINE1,
    ADDRESS_LINE2,
    EMAIL,
    MAP_EMBED,
    PHONE_ADDITIONAL,
    PHONE_ADDITIONAL_TEL,
    PHONE_FIXED,
    PHONE_FIXED_TEL,
    PHONE_WHATSAPP,
    WA_MAIN,
    WA_RESCUE,
} from "../constants/site";

export const Contact = () => (
    <section id="contato" data-testid="contact-section" className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-6 space-y-6">
                    <span className="text-xs font-bold uppercase tracking-wider text-[#ff6200]">
                        Atendimento Rápido
                    </span>
                    <h2 className="display-type text-3xl sm:text-5xl text-neutral-900">
                        FALE COM A TMZ GUINCHO
                    </h2>
                    <p className="text-sm text-neutral-600">
                        Acione nossa equipe agora mesmo pelos canais telefônicos e WhatsApp.
                    </p>

                    <div className="space-y-4 pt-2">
                        <a
                            href={WA_MAIN}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-whatsapp-card"
                            className="p-4 rounded-lg bg-[#f8f9fa] border border-neutral-200 flex items-start gap-4 hover:border-[#ff6200]/50 transition-colors"
                        >
                            <div className="p-2.5 rounded bg-[#ff6200] text-white">
                                <MessageCircle className="w-5 h-5" />
                            </div>
                            <div>
                                <span className="text-[11px] uppercase tracking-wider text-neutral-500 font-bold block">
                                    WhatsApp Principal
                                </span>
                                <span className="mono-type text-base font-bold text-neutral-900">
                                    {PHONE_WHATSAPP}
                                </span>
                            </div>
                        </a>

                        <div className="p-4 rounded-lg bg-[#f8f9fa] border border-neutral-200 flex items-start gap-4">
                            <div className="p-2.5 rounded bg-neutral-900 text-white">
                                <Phone className="w-5 h-5" />
                            </div>
                            <div>
                                <span className="text-[11px] uppercase tracking-wider text-neutral-500 font-bold block">
                                    Telefone Fixo / Adicional
                                </span>
                                <a
                                    href={PHONE_FIXED_TEL}
                                    data-testid="contact-phone-fixed"
                                    className="mono-type text-sm font-bold text-neutral-900 block hover:text-[#ff6200] transition-colors"
                                >
                                    {PHONE_FIXED}
                                </a>
                                <a
                                    href={PHONE_ADDITIONAL_TEL}
                                    data-testid="contact-phone-additional"
                                    className="mono-type text-sm font-bold text-neutral-900 block hover:text-[#ff6200] transition-colors"
                                >
                                    {PHONE_ADDITIONAL}
                                </a>
                            </div>
                        </div>

                        <a
                            href={`mailto:${EMAIL}`}
                            data-testid="contact-email-card"
                            className="p-4 rounded-lg bg-[#f8f9fa] border border-neutral-200 flex items-start gap-4 hover:border-[#ff6200]/50 transition-colors"
                        >
                            <div className="p-2.5 rounded bg-neutral-700 text-white">
                                <Mail className="w-5 h-5" />
                            </div>
                            <div>
                                <span className="text-[11px] uppercase tracking-wider text-neutral-500 font-bold block">
                                    E-mail Comercial
                                </span>
                                <span className="mono-type text-sm text-neutral-800">{EMAIL}</span>
                            </div>
                        </a>
                    </div>
                </div>

                <div className="lg:col-span-6 space-y-6">
                    <span className="text-xs font-bold uppercase tracking-wider text-neutral-500">
                        Base Operacional
                    </span>
                    <div className="p-6 bg-[#f8f9fa] rounded-2xl border border-neutral-200 space-y-4">
                        <div className="flex items-start gap-3">
                            <MapPin className="w-6 h-6 text-[#ff6200] shrink-0" />
                            <div>
                                <span className="text-xs uppercase font-bold text-neutral-500 block">
                                    Endereço da Base
                                </span>
                                <p className="text-sm font-semibold text-neutral-900 mt-1">
                                    {ADDRESS_LINE1}
                                    <br />
                                    {ADDRESS_LINE2}
                                </p>
                            </div>
                        </div>

                        <div className="aspect-[16/9] rounded-xl overflow-hidden border border-neutral-300 relative shadow-sm">
                            <iframe
                                src={MAP_EMBED}
                                title="Mapa da base da Tomizo Logística na Rodovia Régis Bittencourt, km 377, Miracatu - SP"
                                data-testid="contact-map"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                className="absolute inset-0 w-full h-full border-0"
                                allowFullScreen
                            />
                        </div>

                        <a
                            href={WA_RESCUE}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-rescue-btn"
                            className="w-full bg-[#ff6200] hover:bg-[#e05600] text-white py-3.5 rounded font-bold text-xs uppercase tracking-wider block text-center transition-colors shadow-md"
                        >
                            Solicitar Resgate no WhatsApp Agora
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
